// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"81":"6fd7eb82","317":"2feae869","461":"42d8d74c","642":"9f61ba26"}[chunkId] + ".css";
};